<template>
  <data-table
    model="Platform\Models\Event"
  >
    <template v-slot:empty-head>
      <v-icon size="72" :color="$store.getters.app.color_name">Event</v-icon>
    </template>

    <template v-slot:empty-text>
      <p class="subheading">A event is an entity to group actions.</p>
      <p class="subheading">Fill in as many details as relevant for your action.</p>
    </template>

  </data-table>
</template>
<script>
  export default {
    data() {
      return {
      }
    },
    methods: {
    }
  }
</script>